


















import { Component, Mixins } from 'vue-property-decorator';
import Pagination from '@/mixins/pagination';
import ShipmentListItem from '@/components/shipment/list/ShipmentListItem.vue';
import listShipmentsQuery from '@/graphql/queries/ListShipments.gql';
import { ShipmentOrderEnum } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    ShipmentListItem
  },
  apollo: {
    shipments: {
      query: listShipmentsQuery,
      prefetch: true,
      variables() {
        return {
          shipmentArgs: {
            customerOrganizationId: this.$route.params.id,
            orderBy: ShipmentOrderEnum.shipment_status
          },
          showAllStatuses: true,
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data ? data.shipmentsPagination.totalCount : 0;
        return data && data.shipments;
      }
    }
  }
})
export default class Shipments extends Mixins(Pagination) {}
